module.exports = __webpack_public_path__ + "img/chat-send-button.b8793f77.svg";